<template>
<v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">{{ GetEjecucion }}
  <v-app id="inspire" class="overflow-y-auto "v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
 hola mundo
  </v-app>
</v-col>
</template>
<script>
import { EventBus } from "../../event-bus";
import { currencyFormatter, FormatoFecha, HoraFormatter,RedondeoValorCantRed,currencyFormatterCant } from "@/js/Funciones.js";
import VueAutonumeric from "../../components/AutoNumericNuevo";
export default {
  components: {
    VueAutonumeric
  },
  created() { 

  },
  mounted() {
 

  },
  beforeDestroy() {

  },

  data: () => ({ 
    windowSize: { width: "auto", height: "auto" },
    valid: true,
    objTemp:null,
    Retencionfactura: {
      ValorPorc: true,
      Retencion: 0,
    },

    dialog:false
    

  }),

  methods: { 


openViewer_ORIGINAL(e) {
 let pdfWindow = window.open("")
// pdfWindow.document.write('<input type="button" id="bt" onclick="{console.log("carga el contenido nuevo");}" value="Print PDF" />');
// pdfWindow.document.write("<embed width='100%' height='100%' type='application/pdf' src='" + SRC + "' ></embed>")
//span
pdfWindow.document.write(`
<b style="font-size: 42px;"><center>
<pre id="preId">${e}
         </pre>
         </center><b/>`
         
         )
         pdfWindow.print()
      
        /* var _this=this;
         setTimeout(function(){ 
         var req = new XMLHttpRequest();
         var fileName = "prueba.pdf";
         var url = _this.$hostname + _this.$hName + '/configuraciones/imprimir/';
          req.open("GET", url, true);
          // req.setRequestHeader('AutUser', this.$store.getters.GetheadersAxios.AutUser);
          req.setRequestHeader('Authorization', _this.$store.getters.GetheadersAxios.Authorization);
          req.setRequestHeader('X-TENANT-ID', _this.$store.getters.GetheadersAxios["X-TENANT-ID"]);
          req.setRequestHeader('Content-Type', _this.$store.getters.GetheadersAxios["Content-Type"]);
          req.setRequestHeader('ruta', `\Users\DESARR~1\AppData\Local\Temp\temp2335827343501907798.pdf`);
          req.responseType = "blob";
          var blob = new Blob([req.response], { type: "application/pdf" });

          req.onload = function () {

            var url = URL || webkitURL;
                var link = url.createObjectURL(blob);
                let pdfWindow = window.open("d.pdf")
                pdfWindow.document.write("<embed width='100%' height='100%' type='application/pdf' src='" + link + "' ></embed>")
          };
          req.send();
        }, 300);*/
},

openViewer_ORIGINAL2(e) {

 let pdfWindow = window.open("")
// </center> <center> font-size: 42px;margin-left: 350;
if(e.imgQr!=null && e.imgQr.trim().length>0 ){

  pdfWindow.document.write(`

<style>
  @page {
    size: 80mm auto;  /* 80mm, cambia aquí si quieres 58mm o LX-300 */
    margin: 0;
  }
  html, body {
    width: 80mm;
    margin: 0;
    padding: 0;
    font-family: monospace;
  }
  .factura-container {
    width: auto;
    margin: 0;
    padding: 0;
  }
  
</style>


<div  class="factura-container">
<b style="font-size: 42px; width:auto; ">
  <center>
<img id="imgLogo" 
 src="${this.$store.getters.GetConfiguracionGeneral.config.logo}" 
style="max-width: 150px; border:1px solid #000; text-align: center;" />
</center>
<pre id="preId" style=" max-width: auto !important; margin: 0px;padding: 0px; border:1px solid #000;">${e.facturaText}
</pre>
<center>
<img id="imgLogo" 
src="data:image/png;base64,${e.imgQr}" 
style="max-width: 150px; border:1px solid #000; text-align: center; margin: 0px;padding: 0px; " />
 </center>
<pre  style=" max-width: auto !important; margin: 0px;padding: 0px; text-align: center;">
Codigo Seguridad:${e.codsegdgii}.
Fecha Firma Digital:
${e.fechafirmadgii}
</pre>

          <b/> 
</div>` )

}else{
  pdfWindow.document.write(`
<b style="font-size: 42px;">
  <img id="imgLogo" 
                    src="${this.$store.getters.GetConfiguracionGeneral.config.logo}" 
                    style="max-width: 200px; border:1px solid #000; text-align: center; margin-left: 350;" />

<pre id="preId" style="margin: 0px;padding: 0px; text-align: center;">${e.facturaText}
         </pre>
          <b/>` )

}


         pdfWindow.print()
},


openViewer(e) {

 let pdfWindow = window.open("")
// </center> <center> font-size: 42px;margin-left: 350;
if(e.imgQr!=null && e.imgQr.trim().length>0 ){
//border:1px solid #000;
/*html, body width: 950;
.factura-container:950, margin-left:50
imagne logo:max-width: 250px;  
imagne qr style="max-width: 350px;
*/
/*
WILSON
html, body width: 310;
.factura-container:310, margin-left:55
imagne logo:max-width: 150px;  
imagne qr style="max-width: 150px;

*/ 

// center// start
//950
var WINDTH_hbc=410
pdfWindow.document.write(`
<style>
  @page {
    size: 80mm auto;  /* 80mm, cambia aquí si quieres 58mm o LX-300 */
    margin: 0;
  }
  html, body {
    width: ${WINDTH_hbc};
    margin: 0;
    padding: 0;
    font-family: monospace;
  }
  .factura-container {
    width: ${WINDTH_hbc};
    margin: 0;
    padding: 0;
    margin-left:0;

  }
  pre {
    margin: 0;
    padding: 0;
  }
</style>

<div class="factura-container">
<b style="font-size: 18px; width:auto; ">
<center>
  <img src="${this.$store.getters.GetConfiguracionGeneral.config.logo}" 
  style="max-width: 250px;  text-align: center; margin: 0px;padding: 0px;" />
</center>

<pre>${e.facturaText}</pre>

<center>
  <img src="data:image/png;base64,${e.imgQr}" style="max-width: 250px; text-align: center; margin: 0px;padding: 0px; " />
</center>

<pre style=" max-width: auto !important; margin: 0px;padding: 0px; text-align: center;">
Codigo Seguridad: ${e.codsegdgii}
Fecha Firma Digital:
${e.fechafirmadgii}

</pre>
<b/>
</div>
`);


}else{
  pdfWindow.document.write(`
  <style>
  @page {
    size: 80mm auto;  /* 80mm, cambia aquí si quieres 58mm o LX-300 */
    margin: 0;
  }
  html, body {
    width: ${WINDTH_hbc};
    margin: 0;
    padding: 0;
    font-family: monospace;
  }
  .factura-container {
    width: ${WINDTH_hbc};
    margin: 0;
    padding: 0;
    margin-lef:0;
  }
  pre {
    
    margin: 0;
    padding: 0;
  }
</style>

<div class="factura-container">
<b style="font-size: 18px;">
<div>
  <img src="${this.$store.getters.GetConfiguracionGeneral.config.logo}" 
  style="max-width: 250px;  text-align: start; margin: 0px;padding: 0px;" />
</center>

<pre id="preId" style="margin: 0px;padding: 0px;">${e.facturaText}
         </pre>
          <b/>
</div>` )

}

          var _this = this
          setTimeout(function() {
            pdfWindow.print()
          }, 1000)


         
},




 getletra(e) {

      //var letra ="http://fcialalinea.ddns.net/micromarket/imagenMM.mm?pic=imagenes_reportes/LALINEA.jpg"
      var letra
      if (e.length > 0) {
        letra = e.substr(0, 2)
      } else {
        letra = " "
      }

      return letra;


    },


GetPrintFacturaVenta(e) {
  this.dialog=true
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/AnularFactura/PrintFacturaText/" + e.facturasventaPK.secuencia + "/" + e.facturasventaPK.documento,
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          this.openViewer(res.data)
        });
    },





    
  },
  computed: { 
    GetEjecucion() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
     },

},
};
</script>
<style lang="scss">
</style>